import { useState, useEffect, useMemo } from "react";
const combineParams_ = (params, pageParam) => {
  return {
    ...params,
    query: {
      ...params.query,
      offset: pageParam
    }
  };
};
const transformResponse_ = (response) => {
  if ("entries" in response) {
    return response.entries;
  }
};
const getNextPageParam_ = (lastPage) => {
  if ("meta" in lastPage) {
    const metaData = lastPage.meta;
    if (!metaData.count) {
      return void 0;
    }
    if (!!metaData.count && metaData.offset + metaData.limit >= metaData.count) {
      return void 0;
    }
    return metaData.offset + metaData.limit;
  }
};
const resolvePageIndex_ = (params) => {
  return params.query.offset;
};
const useInfiniteQuery = (lazyQuery, params, options) => {
  const {
    combineParams = combineParams_,
    getNextPageParam = getNextPageParam_,
    transformResponse = transformResponse_,
    resolvePageIndex = resolvePageIndex_,
    initialPageParam = 0,
    onError,
    skip,
    onSuccess
  } = options || {};
  const [pageData, setPageData] = useState({});
  const [nextPageParam, setNextPageParam] = useState(initialPageParam);
  const [currentPageParam, setCurrentPageParam] = useState(initialPageParam);
  const [isRtkFetching, setIsRtkFetching] = useState(false);
  const doFetch = async (params2, currentPageParam2) => {
    try {
      const requestParams = combineParams(params2, currentPageParam2);
      setIsRtkFetching(true);
      const response = await lazyQuery(requestParams);
      if (!!response.data) {
        const nextPageParam2 = getNextPageParam(response.data);
        setNextPageParam(nextPageParam2);
        const pageKey = resolvePageIndex(requestParams);
        const pageData2 = transformResponse(response.data);
        setPageData((prev) => ({ ...prev, [pageKey]: pageData2 }));
        onSuccess == null ? void 0 : onSuccess(response.data);
      }
      if (response.error) {
        throw response.error;
      }
    } catch (e) {
      onError == null ? void 0 : onError(e);
    } finally {
      setIsRtkFetching(false);
    }
  };
  useEffect(() => {
    if (skip) return;
    setPageData({});
    setNextPageParam(initialPageParam);
    setCurrentPageParam(initialPageParam);
    doFetch(params, initialPageParam).then(() => {
    });
  }, [JSON.stringify(params), skip]);
  const hasNextPage = useMemo(() => {
    return !!nextPageParam;
  }, [nextPageParam]);
  const fetchNextPage = () => {
    if (nextPageParam !== void 0) {
      doFetch(params, nextPageParam).then(() => {
      });
      setCurrentPageParam(nextPageParam);
      setNextPageParam(void 0);
    }
  };
  const data = useMemo(() => {
    const keys = Object.keys(pageData).sort((a, b) => parseInt(a) - parseInt(b));
    return keys.reduce((acc, key) => {
      return [...acc, ...pageData[key]];
    }, []);
  }, [pageData]);
  const isFetchingNextPage = useMemo(() => {
    return isRtkFetching && nextPageParam !== currentPageParam;
  }, [currentPageParam, isRtkFetching, nextPageParam]);
  const isFetchingInitialPage = useMemo(() => {
    return isRtkFetching && nextPageParam === currentPageParam;
  }, [currentPageParam, isRtkFetching, nextPageParam]);
  return {
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isFetchingInitialPage,
    data
  };
};
const useInfiniteQuery$1 = useInfiniteQuery;
export {
  useInfiniteQuery$1 as default
};
